import React, { useState } from "react";
import { connect } from "react-redux";
import { setcontactlist } from "../../../Redux/Actions/actions";
// Component
import UserDetails from "./User-Details.component";
import Interactiontab from "./user-list-child-component/Interaction-tab.component";
import Sessiontab from "./user-list-child-component/Session-tab.component";
import Tickethistory from "./user-list-child-component/Ticket-history.component";
import FilesTab from "./user-list-child-component/Files-tab.component";
import SurveyTab from "./user-list-child-component/Survey-tab.component";
import { Box, Typography } from "@mui/material";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { MdWorkHistory } from "react-icons/md";
import { FaUserClock } from "react-icons/fa";
import { FaFile } from "react-icons/fa6";
import { FaTicketAlt } from "react-icons/fa";
import { RiSurveyFill } from "react-icons/ri";
import { FaRobot } from "react-icons/fa";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      style={{ padding: "0px" }}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};

const UserlistComponent = (props) => {
  const { handleSendMsg } = props;
  let permission = JSON.parse(localStorage.getItem("permission"));
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        height: "100%",
        width: "calc(100% - 50vw)",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        background: "white",
        overflow: "hidden",
      }}
    >
      <Box className="p-2 pb-0">
        <Box
          sx={{
            maxHeight: "105px",
            width: "100%",
            overflowY: "hidden",
            display: "flex",
            flexDirection: "column",
            background: "#f7f7f7",
            borderRadius: "7px",
          }}
          className="position-relative p-2"
        >
          <UserDetails />
        </Box>
      </Box>

      <Box
        sx={{
          height: "calc(100% - 140px)",
          width: "100%",
        }}
      >
        {/* new  */}
        <Box
          sx={{
            flexGrow: 1,
            maxWidth: { xs: 320, sm: 480 },
            bgcolor: "background.paper",
          }}
        >
          <Box className="tab-history-main">
            <Typography
              variant="h6"
              sx={{
                fontSize: "15px",
                fontWeight: "600",
                color: "#0b3363",
              }}
              gutterBottom
              className="border-bottom px-2"
            >
              History
            </Typography>
            <Box
              sx={{ borderBottom: 1, borderColor: "divider" }}
              className="px-2"
            >
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="visible arrows tabs example"
                sx={{
                  minHeight: "34px",
                  ".MuiTabScrollButton-root": {
                    width: "20px",
                  },
                }}
              >
                {/* Interaction History  */}
                {permission.map((module) => {
                  if (module.moduleName === "INTERACTION") {
                    const value = module.screen.find(
                      (item) =>
                        item.screenId === "INTERACTION_HISTORY" &&
                        item.read &&
                        item.write
                    );
                    if (value) {
                      return (
                        <Tab
                          size="small"
                          icon={<FaUserClock />}
                          iconPosition="start"
                          label="Interaction"
                          sx={{
                            fontSize: "13px",
                            color: "#0b3363",
                            textTransform: "capitalize",
                            minWidth: "75px",
                            minHeight: "20px",
                            padding: " 5px",
                            fontSize: "12px",
                          }}
                        />
                      );
                    } else {
                      return (
                        <Tab
                          size="small"
                          icon={<FaUserClock />}
                          disabled
                          iconPosition="start"
                          label="Interaction"
                          sx={{
                            fontSize: "13px",
                            color: "#0b3363",
                            textTransform: "capitalize",
                            minWidth: "75px",
                            minHeight: "20px",
                            padding: " 5px",
                            fontSize: "12px",
                          }}
                        />
                      );
                    }
                  }
                })}
                {/* Session History */}
                {permission.map((module) => {
                  if (module.moduleName === "INTERACTION") {
                    const value = module.screen.find(
                      (item) =>
                        item.screenId === "SESSION_HISTORY" &&
                        item.read &&
                        item.write
                    );
                    if (value) {
                      return (
                        <Tab
                          label="Session"
                          size="small"
                          icon={<MdWorkHistory />}
                          iconPosition="start"
                          sx={{
                            fontSize: "13px",
                            color: "#0b3363",
                            textTransform: "capitalize",
                            minWidth: "75px",
                            minHeight: "20px",
                            padding: " 5px",
                            fontSize: "12px",
                          }}
                        />
                      );
                    } else {
                      return (
                        <Tab
                          label="Session"
                          size="small"
                          disabled
                          icon={<MdWorkHistory />}
                          iconPosition="start"
                          sx={{
                            fontSize: "13px",
                            color: "#0b3363",
                            textTransform: "capitalize",
                            minWidth: "75px",
                            minHeight: "20px",
                            padding: " 5px",
                            fontSize: "12px",
                          }}
                        />
                      );
                    }
                  }
                })}
                {/* Files History  */}
                {permission.map((module) => {
                  if (module.moduleName === "INTERACTION") {
                    const value = module.screen.find(
                      (item) =>
                        item.screenId === "FILE" && item.read && item.write
                    );
                    if (value) {
                      return (
                        <Tab
                          size="small"
                          icon={<FaFile />}
                          iconPosition="start"
                          label="Files"
                          sx={{
                            fontSize: "13px",
                            color: "#0b3363",
                            textTransform: "capitalize",
                            minWidth: "75px",
                            minHeight: "20px",
                            padding: " 5px",
                            fontSize: "12px",
                          }}
                        />
                      );
                    } else {
                      return (
                        <Tab
                          size="small"
                          icon={<FaFile />}
                          iconPosition="start"
                          label="Files"
                          disabled
                          sx={{
                            fontSize: "13px",
                            color: "#0b3363",
                            textTransform: "capitalize",
                            minWidth: "75px",
                            minHeight: "20px",
                            padding: " 5px",
                            fontSize: "12px",
                          }}
                        />
                      );
                    }
                  }
                })}
                {/* Ticket History  */}
                {permission.map((module) => {
                  if (module.moduleName === "INTERACTION") {
                    const value = module.screen.find(
                      (item) =>
                        item.screenId === "TICKET_SUMMARY" &&
                        item.read &&
                        item.write
                    );
                    if (value) {
                      return (
                        <Tab
                          size="small"
                          icon={<FaTicketAlt />}
                          iconPosition="start"
                          label="Ticket"
                          sx={{
                            fontSize: "13px",
                            color: "#0b3363",
                            textTransform: "capitalize",
                            minWidth: "75px",
                            minHeight: "20px",
                            padding: " 5px",
                            fontSize: "12px",
                          }}
                        />
                      );
                    } else {
                      return (
                        <Tab
                          size="small"
                          icon={<FaTicketAlt />}
                          iconPosition="start"
                          disabled
                          label="Ticket"
                          sx={{
                            fontSize: "13px",
                            color: "#0b3363",
                            textTransform: "capitalize",
                            minWidth: "75px",
                            minHeight: "20px",
                            padding: " 5px",
                            fontSize: "12px",
                          }}
                        />
                      );
                    }
                  }
                })}
                {/* SmartX History  */}
                {permission.map((module) => {
                  if (module.moduleName === "INTERACTION") {
                    const value = module.screen.find(
                      (item) =>
                        item.screenId === "SMARTX" && item.read && item.write
                    );
                    if (value) {
                      return (
                        <Tab
                          size="small"
                          icon={<FaRobot />}
                          iconPosition="start"
                          label="SmartX"
                          sx={{
                            fontSize: "13px",
                            color: "#0b3363",
                            textTransform: "capitalize",
                            minWidth: "75px",
                            minHeight: "20px",
                            padding: " 5px",
                            fontSize: "12px",
                          }}
                        />
                      );
                    } else {
                      return (
                        <Tab
                          size="small"
                          icon={<FaRobot />}
                          iconPosition="start"
                          disabled
                          label="SmartX"
                          sx={{
                            fontSize: "13px",
                            color: "#0b3363",
                            textTransform: "capitalize",
                            minWidth: "75px",
                            minHeight: "20px",
                            padding: " 5px",
                            fontSize: "12px",
                          }}
                        />
                      );
                    }
                  }
                })}
                {/* Survey  History  */}
                {permission.map((module) => {
                  if (module.moduleName === "INTERACTION") {
                    const value = module.screen.find(
                      (item) =>
                        item.screenId === "SURVEY_DETAILS" &&
                        item.read &&
                        item.write
                    );
                    if (value) {
                      return (
                        <Tab
                          size="small"
                          icon={<RiSurveyFill />}
                          iconPosition="start"
                          label="Survey"
                          sx={{
                            fontSize: "13px",
                            color: "#0b3363",
                            textTransform: "capitalize",
                            minWidth: "75px",
                            minHeight: "20px",
                            padding: " 5px",
                            fontSize: "12px",
                          }}
                        />
                      );
                    } else {
                      return (
                        <Tab
                          size="small"
                          icon={<RiSurveyFill />}
                          iconPosition="start"
                          disabled
                          label="Survey"
                          sx={{
                            fontSize: "13px",
                            color: "#0b3363",
                            textTransform: "capitalize",
                            minWidth: "75px",
                            minHeight: "20px",
                            padding: " 5px",
                            fontSize: "12px",
                          }}
                        />
                      );
                    }
                  }
                })}
              </Tabs>
            </Box>
          </Box>
          <Box className="p-2">
            {/* Interaction History Tab content */}
            <CustomTabPanel value={value} index={0} className="tab-sub">
              <Interactiontab />
            </CustomTabPanel>
            {/* Session History tab content */}
            <CustomTabPanel value={value} index={1}>
              <Sessiontab />
            </CustomTabPanel>
            {/* file tab content  */}
            <CustomTabPanel value={value} index={2}>
              <FilesTab handleSendMsg={handleSendMsg} />
            </CustomTabPanel>
            {/* ticket tab content  */}
            <CustomTabPanel value={value} index={3}>
              <Tickethistory />
            </CustomTabPanel>
            {/* survey tab content  */}
            <CustomTabPanel value={value} index={4}>
              <SurveyTab />
            </CustomTabPanel>
            {/* SmartX tab content  */}
            <CustomTabPanel value={value} index={5}>
              <SurveyTab />
            </CustomTabPanel>
          </Box>
        </Box>

        {/* new end  */}
      </Box>
    </Box>
  );
};

export default connect(mapStateToProps, {
  setcontactlist,
})(UserlistComponent);
